import React, {useEffect, useRef, useState} from 'react';
import {Alert, Button} from '@mui/material';

let scriptPromise;
export function loadRecaptcha() {
    if (window.grecaptcha?.render) return Promise.resolve(window.grecaptcha);
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            const timer = setTimeout(() => { script.remove(); scriptPromise = null; reject(new Error('Verification could not load. Please try again.')); }, 15000);
            window.easywareRecaptchaLoaded = () => { clearTimeout(timer); resolve(window.grecaptcha); };
            script.src = 'https://www.google.com/recaptcha/api.js?onload=easywareRecaptchaLoaded&render=explicit';
            script.async = true;
            script.onerror = () => { clearTimeout(timer); script.remove(); scriptPromise = null; reject(new Error('Verification could not load. Please try again.')); };
            document.head.appendChild(script);
        });
    }
    return scriptPromise;
}

export default function RecaptchaGate({formId, custref, onVerified}) {
    const container = useRef();
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!custref) return;
        let active = true;
        let widget;
        let api;
        const controller = new AbortController();
        setError('');
        const setup = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_SUBMIT_URL}/checkout/recaptcha/${formId}`, {signal: controller.signal});
                const config = await response.json();
                if (!response.ok || !config.siteKey) throw new Error(config.error || 'Verification is unavailable. Please try again.');
                api = await loadRecaptcha();
                if (!active) return;
                widget = api.render(container.current, {
                    sitekey: config.siteKey,
                    callback: (token) => {
                        if (!active) return;
                        // Google responses are verified and consumed by the payment endpoint.
                        onVerified({token, formId, custref, expiresAt: Math.floor(Date.now() / 1000) + 110});
                    },
                    'expired-callback': () => { if (active) setError('Verification expired. Please check the box again.'); },
                    'error-callback': () => { if (active) setError('Verification could not connect. Please try again.'); }
                });
            } catch (e) {
                if (active) setError(e.message);
            }
        };
        setup();
        return () => { active = false; controller.abort(); if (widget !== undefined) api.reset(widget); if (container.current) container.current.innerHTML = ''; };
    }, [formId, custref, onVerified, attempt]);
    return <div style={{margin: '20px 0'}}>
        <p>Please verify that you’re human before continuing.</p>
        <div ref={container}/>
        {error && <><Alert severity="error">{error}</Alert><Button onClick={() => setAttempt(attempt + 1)}>Retry verification</Button></>}
    </div>;
}
